import React from 'react';
import AccordionSection from '../shared/AccrodionSection';
import { ShowPageLayout } from 'framework/ui/layout';
import { Box, Grid2 as Grid } from '@mui/material';
import QualificationView from './qualification/QualificationView';
import NextCareerReviewView from './nextReview/NextCareerReviewView';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';
import ExpertiseSection from 'domain/people/employee/expertise/ExpertiseSection';
import { useShowContext } from 'framework/show';
import {
  BUSINESS_ANALYST_ID,
  PROJECT_MANAGER_ID,
  QA_ENGINEER_ID,
  SOFTWARE_ENGINEER_ID,
  UI_UX_DESIGNER_ID,
} from 'domain/shared/employee';

const SHOW_EXPERTISE_POSITIONS = [
  PROJECT_MANAGER_ID,
  BUSINESS_ANALYST_ID,
  UI_UX_DESIGNER_ID,
  QA_ENGINEER_ID,
  SOFTWARE_ENGINEER_ID,
];

const CareerSection: React.FC = React.memo(() => {
  const { isFeatureEnabled } = useFeatureToggle();
  const { data: employeeData } = useShowContext();
  const positionId = employeeData?.positionId;
  const canShowExpertise = SHOW_EXPERTISE_POSITIONS.includes(positionId);

  return (
    <Box sx={{ '& > .MuiPaper-root': { minHeight: 'unset' } }}>
      <ShowPageLayout minHeight="100px">
        <AccordionSection title="My career" lazyLoad>
          <Box>
            <Grid container rowSpacing={{ xs: 3, md: 1 }} columnSpacing={{ xs: 1, md: 3 }} mt={{ xs: 2, md: 0 }}>
              <Grid size={{ xs: 6, md: 6 }}>
                <QualificationView />
                <NextCareerReviewView />
              </Grid>

              <Grid size={{ xs: 6, md: 6 }}>
                {isFeatureEnabled(Features.EXPERTISE) && canShowExpertise && <ExpertiseSection />}
              </Grid>
            </Grid>
          </Box>
        </AccordionSection>
      </ShowPageLayout>
    </Box>
  );
});

export default CareerSection;
